import { BatteryTier } from './BatteryOffer';

export enum PaymentType {
  Cash = 'cash',
  Loan = 'loan',
  PPA = 'ppa',
  PrepaidTpoCash = 'prepaid_tpo_cash',
  PrepaidTpoCashWithLoan = 'prepaid_tpo_cash_with_loan',
}

export type CashPricing = {
  cash_incentives: number;
  cash_payback_years: number;
  lifetime_cash_savings: number;
  system_cost_with_cash_incentives: number;
};

export type LoanPricing = {
  initial_monthly_savings: number;
  lifetime_interest: number;
  lifetime_savings: number;
  loan_incentives: number;
  monthly_savings: number;
  payment: number;
  rate: number;
  system_cost: number; // TODO @deprecated use system_cost_with_loan_incentives instead, remove after 2026-03-20
  system_cost_with_loan_incentives?: number;
  term: number;
};

// Prepaid TPO paid for upfront in cash.
export type PrepaidTpoCashPricing = {
  discount_rate: number;
  lifetime_savings: number;
  payback_years: number;
  system_cost: number;
  system_cost_with_incentives: number;
};

// Prepaid TPO where the discounted prepayment is financed with a loan.
export type PrepaidTpoCashWithLoanPricing = {
  discount_rate: number;
  initial_monthly_savings: number;
  lifetime_interest: number;
  lifetime_savings: number;
  payment: number;
  rate: number;
  system_cost?: number;
  system_cost_with_incentives: number;
  term: number;
};

// A quote may offer either flavor, both, or neither.
export type PrepaidTpoPricing = {
  cash?: PrepaidTpoCashPricing;
  cash_with_loan?: PrepaidTpoCashWithLoanPricing;
};

export type PpaPricing = {
  battery_count?: number; // TODO @deprecated use battery_tiers instead, remove after 2026-03-20
  battery_tiers?: BatteryTier[];
  escalator: number;
  includes_storage?: boolean;
  initial_monthly_payment: number;
  lifetime_savings: number;
  monthly_savings: number;
  ppa_product_id: string;
  system_cost: number;
  term: number;
};
